import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import placeholder from 'lib/placeholder';

import ChecklistItem from './ChecklistItem';

const Checklist = ({
  className,
  hasPhysicalStore,
  isCnpjValid,
  isMarketplace,
  isVerified,
}) => (
  <div className={twJoin('flex w-full flex-wrap gap-x-4', className)}>
    <ChecklistItem checked={isVerified}>
      {isMarketplace
        ? placeholder('descriptions.verifiedMarketplace')
        : placeholder('descriptions.verifiedStore')}
    </ChecklistItem>
    <ChecklistItem checked={isCnpjValid}>
      {placeholder('descriptions.verifiedStoreCnpj')}
    </ChecklistItem>
    <ChecklistItem checked={hasPhysicalStore}>
      {placeholder('descriptions.storeHasPhysicalStore')}
    </ChecklistItem>
  </div>
);

Checklist.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  hasPhysicalStore: PropTypes.bool.isRequired,
  isCnpjValid: PropTypes.bool.isRequired,
  isMarketplace: PropTypes.bool.isRequired,
  isVerified: PropTypes.bool.isRequired,
};

export default Checklist;
